/* W-GIFT-20260908: real gift SKU lines; all cart writes share one queue. */
(function () {
  'use strict';
  if (window.WD_GIFTS) return;
  var config = window.WD_GIFT_CONFIG;
  if (!config) return;
  var nativeFetch = window.fetch.bind(window), tail = Promise.resolve();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var kinds = ['brush', 'bottle', 'shipping'];
  var lastCart = null; // latest full cart response (used for gift checks)
  function remember(cart) { if (cart && Array.isArray(cart.items) && typeof cart.item_count === 'number') lastCart = cart; return cart; }
  function announce(cart) { try { document.dispatchEvent(new CustomEvent('wandry:cart-updated', { detail: cart })); } catch (_) {} }
  function enqueue(job) { var result = tail.then(job); tail = result.catch(function () {}); return result; }
  function kindOf(item) { return kinds.find(function (kind) { return String(item.variant_id || item.id) === String(config[kind]); }); }
  // Retired 2026-09-17: remove only the three legacy gift SKUs, never add them.
  function desired(cart) { return { brush: 0, bottle: 0, shipping: 0 }; }
  function plan(cart) {
    var counts = desired(cart), updates = {}, add = [];
    kinds.forEach(function (kind) {
      var lines = cart.items.filter(function (item) { return kindOf(item) === kind; });
      if (lines.some(function (item) { return item.original_price !== 0; })) throw Error('Gift price must be zero');
      lines.forEach(function (item, i) { var quantity = i === 0 ? counts[kind] : 0; if (item.quantity !== quantity) updates[item.key] = quantity; });
      if (!lines.length && counts[kind]) {
        var properties = { _wandry_gift: kind, _wandry_gift_rule: 'W-GIFT-20260908' };
        properties['구매 혜택'] = kind === 'shipping' ? '9,000원 → 0원' : '26,000원 → 0원';
        add.push({ id: config[kind], quantity: counts[kind], properties: properties });
      }
    });
    return { updates: updates, add: add };
  }
  async function request(path, body) {
    var response = await nativeFetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store' });
    if (!response.ok) throw Error('Gift cart request failed (' + response.status + ')');
    var data = await response.json();
    return path === 'cart.js' || (data && Array.isArray(data.items) && typeof data.item_count === 'number') ? remember(data) : data;
  }
  async function reconcile(initialCart) {
    // Use the full server mutation response once; re-read after gift mutations.
    var changed = false;
    for (var pass = 0; pass < 5; pass++) {
      var cart = pass === 0 && initialCart ? remember(initialCart) : await request('cart.js'), next = plan(cart);
      if (Object.keys(next.updates).length) { await request('cart/update.js', { updates: next.updates }); changed = true; continue; }
      if (next.add.length) { await request('cart/add.js', { items: next.add }); changed = true; continue; }
      return { cart: cart, changed: changed };
    }
    throw Error('Gift quantities are still changing');
  }
  function sectionNames() {
    var names = [];
    ['cart-drawer', 'cart-items'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (el && el.getSectionsToRender) el.getSectionsToRender().forEach(function (s) { var name = s.section || s.id; if (names.indexOf(name) < 0) names.push(name); });
    });
    return names.slice(0, 5);
  }
  async function sections(cart, names) {
    if (!names.length) return cart;
    var response = await nativeFetch(root + '?sections=' + encodeURIComponent(names.join(',')), { cache: 'no-store' });
    if (!response.ok) throw Error('Gift cart display failed');
    cart.sections = await response.json();
    if (names.some(function (name) { return !cart.sections[name]; })) throw Error('Gift cart section missing');
    return cart;
  }
  function render(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && cart.sections && cart.sections['cart-drawer']) { drawer.classList.toggle('is-empty', !cart.item_count); drawer.renderContents(cart, true); }
    var items = document.querySelector('cart-items');
    if (items && items.getSectionsToRender) {
      items.classList.toggle('is-empty', !cart.item_count);
      var footer = document.getElementById('main-cart-footer'); if (footer) footer.classList.toggle('is-empty', !cart.item_count);
      items.getSectionsToRender().forEach(function (s) {
        var html = cart.sections && cart.sections[s.section || s.id], wrapper = document.getElementById(s.id);
        if (html && wrapper) (wrapper.querySelector(s.selector) || wrapper).innerHTML = items.getSectionInnerHTML(html, s.selector);
      });
    }
  }
  function showError(target) {
    target = target && target.isConnected ? target : document.querySelector('cart-drawer.active .drawer__footer, cart-items, .wd-cart-feedback');
    if (!target) return;
    var el = target.querySelector('.wd-gift-error');
    if (!el) { el = document.createElement('p'); el.className = 'wd-gift-error'; el.setAttribute('role', 'alert'); target.appendChild(el); }
    el.textContent = '장바구니를 업데이트하지 못했어요. 잠시 후 다시 시도해 주세요.';
  }
  function clearError() { document.querySelectorAll('.wd-gift-error').forEach(function (el) { el.remove(); }); }
  function ensure(options) {
    return enqueue(async function () {
      try { var result = await reconcile(); if (result.changed || (options && options.render)) render(await sections(result.cart, sectionNames())); clearError(); return result.cart; }
      catch (error) { error.wandryGift = true; showError(); throw error; }
    });
  }
  // Free gift lines sent with the added item; Shopify merges lines with the same variant+properties.
  function itemsFor(variantId, quantity) { return []; }
  // Fast add: send item and gifts in one cart/add and return the response as is; gifts are reconciled afterwards.
  function addFast(options) {
    var item = options.item, timeout = options.timeout || 12000;
    return enqueue(async function () {
      var payload = { items: [item].concat(itemsFor(item.id, item.quantity)) };
      if (options.sections && options.sections.length) { payload.sections = options.sections.join(','); payload.sections_url = options.sections_url || location.pathname; }
      var controller = typeof AbortController === 'function' ? new AbortController() : null, timer = controller && setTimeout(function () { controller.abort(); }, timeout);
      try {
        var response = await nativeFetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload), signal: controller ? controller.signal : undefined });
        if (!response.ok) { var error = Error('Gift cart request failed (' + response.status + ')'); error.status = response.status; throw error; }
        var data = await response.json();
        lastCart = null; // next check runs after a re-fetch
        return data;
      } finally { if (timer) clearTimeout(timer); }
    }).then(function (data) {
      // Follow-up reconcile (re-render only on change); announce the latest cart when done.
      ensure({ render: false }).then(announce).catch(function () {});
      return data;
    });
  }
  function settle() { return tail; }
  window.WD_GIFTS = { ensure: ensure, showError: showError, itemsFor: itemsFor, addFast: addFast, settle: settle, cart: function () { return lastCart; } };
  window.fetch = function (input, options) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
    var method = String(options && options.method || (input && input.method) || 'GET').toUpperCase();
    var match = url.origin === location.origin && url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/);
    if (!match || method !== 'POST') return nativeFetch(input, options);
    // Capture a stable key before this write waits behind earlier cart writes.
    if (match[1] === 'change' && options && typeof options.body === 'string') {
      try { var data = JSON.parse(options.body); if (data.line && !data.id) {
        var row = document.querySelector('#CartDrawer-Item-' + data.line + ', #CartItem-' + data.line);
        if (row && row.dataset.wdLineKey) { data.id = row.dataset.wdLineKey; delete data.line; options = Object.assign({}, options, { body: JSON.stringify(data) }); }
      } } catch (_) {}
    }
    return enqueue(async function () {
      var response = await nativeFetch(input, options);
      if (!response.ok) return response;
      var original = await response.clone().json();
      try {
        var fullCart = match[1] !== 'add' && Array.isArray(original.items) && typeof original.item_count === 'number' ? original : null;
        var result = await reconcile(fullCart), names = Object.keys(original.sections || {});
        var cart = result.cart;
        if (!result.changed && names.length && names.every(function (name) { return original.sections[name]; })) cart.sections = original.sections;
        else cart = await sections(cart, names);
        var data = match[1] === 'add' ? Object.assign({}, original, { _wandryCart: cart }, names.length ? { sections: cart.sections } : {}) : Object.assign({}, original, cart);
        clearError();
        var headers = new Headers(response.headers); headers.delete('content-length'); headers.delete('content-encoding');
        return new Response(JSON.stringify(data), { status: response.status, statusText: response.statusText, headers: headers });
      } catch (_) {
        // The requested mat write succeeded. Preserve success so retry cannot add it twice.
        showError(); return response;
      }
    });
  };
  function init(refresh) { ensure({render: refresh === true}).catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  window.addEventListener('pageshow', function (event) { if (event.persisted) init(true); });
})();
